var shipping_states = {
  "PA" 		: { free_shipping_at: 100, ups_transit_time: 1 }, //19104
  "OH"		: { free_shipping_at: 100, ups_transit_time: 2 },
  "WV" 		: { free_shipping_at: 100, ups_transit_time: 2 },
  "VA"		: { free_shipping_at: 100, ups_transit_time: 1 },
  "MD"		: { free_shipping_at: 100, ups_transit_time: 1 },
  "DE"		: { free_shipping_at: 100, ups_transit_time: 2 },
  "NJ"		: { free_shipping_at: 100, ups_transit_time: 1 },
  "CT" 		: { free_shipping_at: 100, ups_transit_time: 1 },
  "NY"		: { free_shipping_at: 150, ups_transit_time: 1 },
  "ME"		: { free_shipping_at: 150, ups_transit_time: 2 },
  "VT"		: { free_shipping_at: 150, ups_transit_time: 2 },
  "NH" 		: { free_shipping_at: 150, ups_transit_time: 2 },
  "MA" 		: { free_shipping_at: 100, ups_transit_time: 2 },
  "RI" 		: { free_shipping_at: 150, ups_transit_time: 2 },
  "NC" 		: { free_shipping_at: 150, ups_transit_time: 2 },
  "SC" 		: { free_shipping_at: 150, ups_transit_time: 2 },
  "GA"		: { free_shipping_at: 150, ups_transit_time: 2 },
  "FL"		: { free_shipping_at: 150, ups_transit_time: 2 },
  "AL"		: { free_shipping_at: 150, ups_transit_time: 2 },
  "TN"		: { free_shipping_at: 150, ups_transit_time: 2 },
  "KY"		: { free_shipping_at: 150, ups_transit_time: 2 },
  "IN"  	: { free_shipping_at: 150, ups_transit_time: 2 },
  "MI" 		: { free_shipping_at: 150, ups_transit_time: 2 },
  "WI" 		: { free_shipping_at: 150, ups_transit_time: 2 },
  "IL" 		: { free_shipping_at: 150, ups_transit_time: 2 },
  "MO"		: { free_shipping_at: 150, ups_transit_time: 2 },
  "MN"		: { free_shipping_at: 150, ups_transit_time: 2 },
  "NM"		: { free_shipping_at: 150, ups_transit_time: 3 },
  "MS" 		: { free_shipping_at: 150, ups_transit_time: 2 },
  "LA"		: { free_shipping_at: 150, ups_transit_time: 3 },
  "AR"		: { free_shipping_at: 150, ups_transit_time: 3 },
  "IA"  	: { free_shipping_at: 150, ups_transit_time: 2 },
  "SD"		: { free_shipping_at: 150, ups_transit_time: 2 },
  "NE"		: { free_shipping_at: 150, ups_transit_time: 2 },
  "KS"		: { free_shipping_at: 150, ups_transit_time: 3 },
  "OK"		: { free_shipping_at: 150, ups_transit_time: 3 },
  "TX"		: { free_shipping_at: 175, ups_transit_time: 3 },
  "MT"		: { free_shipping_at: 200, ups_transit_time: 3 },
  "CO"		: { free_shipping_at: 200, ups_transit_time: 3 },
  "AZ"		: { free_shipping_at: 200, ups_transit_time: 3 },
  "ND"		: { free_shipping_at: 225, ups_transit_time: 3 },
  "WY"		: { free_shipping_at: 225, ups_transit_time: 3 },
  "UT"		: { free_shipping_at: 225, ups_transit_time: 3 },
  "ID"		: { free_shipping_at: 225, ups_transit_time: 3 },
  "NV"		: { free_shipping_at: 225, ups_transit_time: 3 },
  "CA"		: { free_shipping_at: 225, ups_transit_time: 3 },
  "WA"		: { free_shipping_at: 225, ups_transit_time: 3 },
  "OR"		: { free_shipping_at: 225, ups_transit_time: 3 },
  "HI"		: { free_shipping_at: 0, ups_transit_time: 2 },
  "AK"		: { free_shipping_at: 0, ups_transit_time: 2 },
  "XX"		: { free_shipping_at: 0, ups_transit_time: 0 }
}

function InitCustomLocationBasedRules(){
  debug.func(console_pre + arguments.callee.name, console_colors);
  if(HasCookie("TC-LBR-Location")){
    ExecLocationBasedRules();
  }
}


function GetLocationFromIP(){
  debug.func(console_pre + arguments.callee.name, console_colors);
  if(!HasCookie("TC-LBR-Location")){
    GetGeoInfoAPI().then(function(data) {
      debug.log(data);
      SaveLocationToCookie(data);
      ExecLocationBasedRules();
    });
  }
}

function SaveLocationToCookie(data){
  debug.func(console_pre + arguments.callee.name, console_colors);
  $.cookie("TC-LBR-Location", JSON.stringify(data));
}

function ExecLocationBasedRules(){
  debug.func(console_pre + arguments.callee.name, console_colors);
  //var state_info = GetTierInfoByState(selected_state);
  var location_info = JSON.parse($.cookie("TC-LBR-Location"));
  if(location_info.country_code == "US"){
    var StateRulesInfo = GetRulesInfoByState(location_info.region);
    if(StateRulesInfo){
      /*
      var free_shipping_at = StateRulesInfo.free_shipping_at;
      if(free_shipping_at > 0){
        var banner_msg = "📦 Free shipping on orders over $" + free_shipping_at + ".";
        AddSlideToTopHeaderBanner("free-shipping-over", banner_msg);
      }
      */
    }
  }
}





function GetRulesInfoByState(state){
  debug.func(console_pre + arguments.callee.name, console_colors);
  var state_info = shipping_states[state];
  current_transit_time = state_info.ups_transit_time;
  return state_info;
}

function GetGeoInfoAPI(){
  debug.func(console_pre + arguments.callee.name, console_colors);
  return new Promise((resolve, reject) => {
    $.ajax({
      url: 'https://taylorchipdev.com/dev/web/functions/version/1.0/getgeoinfo.php?func=GetGeoInfo',
      type: 'GET',
      success: function(data) {
        resolve(JSON.parse(data));
        // var c_info_loc = data;
        // if(c_info_loc.country == "US"){
        //   var selected_state = c_info_loc.region;
        //   UpdateBannerByStateInfo(GetTierInfoByState(selected_state));
        // }
      },
      error: function(err) {
        reject(err);
      }
    })
  });
}

async function LoadStateBasedRules(){
  debug.func(console_pre + arguments.callee.name, console_colors);
    var result = null;  
    console.log("loading state by ip (promise)");
    var selected_state;
    if(HasCookie("selected_state")){
      selected_state = $.cookie("selected_state");
      var state_info = GetTierInfoByState(selected_state);
      $.cookie("selected_state", selected_state);
      if(state_info){
        var free_shipping_at = state_info.free_shipping_at;
        var banner_msg = "FREE shipping on orders over $" + free_shipping_at + "!";
        if(free_shipping_at == 0){
          banner_msg = "Welcome to Taylor Chip!";
        }
        UpdateBannerWithFreeShippingMsg(banner_msg);
      }
  
    } else{
 
    }
    return result;
}


function SlideHeaderBanner(){
    setTimeout(function(){ 
      var slider = $(".top-banner .slider-wrapper");
      var current_slide = parseInt(slider.attr("rel"));
      var next_slide = current_slide+1;
  
      if(slider.find(".slide-"+next_slide).length <= 0){
        current_slide = 2;
        next_slide = 1;
        //console.log("restarting");
      }
  
  
      slider.find(".slide-"+current_slide).fadeOut(800, function() {
        slider.find(".slide-"+next_slide).fadeIn(800);
      });
  
  
      slider.attr("rel", next_slide);
      SlideHeaderBanner();
    }, parseInt(4000));
  }
  
  function UpdateBannerWithFreeShippingMsg(msg){
    if($(".top-banner .slider-wrapper .slide-2").length){
      $(".top-banner .slider-wrapper .slide-2").text(msg);
    }else{
      var slide_html = '<div class="slide slide-2" style="display:block">' + msg + '</div>';
      $(".top-banner .slider-wrapper").append(slide_html); 
    }
  
  }

  function UpdateBannerByStateInfo(state_info){
    if(state_info){
      console.log("updating bannsar");
      var free_shipping_at = state_info.free_shipping_at;
      var banner_msg = "FREE shipping on orders over $" + free_shipping_at + "!";
      if(free_shipping_at == 0){
        banner_msg = "Welcome to Taylor Chip!";
      }
      UpdateBannerWithFreeShippingMsg(banner_msg);
    }
  }
  